function waitForConfig () {
  return new Promise((resolve) => {
    const check = () => {
      if (window.APP_CONFIG) {
        resolve()
      } else {
        setTimeout(check, 50)
      }
    }
    check()
  })
}

waitForConfig().then(() => {
  import('./main-start')
})
